import React from 'react';
import propTypes from 'prop-types';
import Resize from './Resize';
import logos1x4 from '../assets/adverts/logos1x4.png';
import logos4x1 from '../assets/adverts/logos4x1.png';

const advertMap = {
	lw1x4: { src: logos1x4, ratio: '1x4' },
	lw4x1: { src: logos4x1, ratio: '6x1' },
	el1x4: { src: logos1x4, ratio: '1x4' },
	el4x1: { src: logos4x1, ratio: '6x1' },
};

export default function Advert(props) {
	const { className, type } = props;

	const { ratio, src } = advertMap[type] || {};

	return (
		<Resize
			className={className}
			ratio={ratio}
			component={(cprops) => (
				<img
					className={cprops.className}
					src={src}
					alt="advert"
				/>
			)}
		/>
	);
}

Advert.defaultProps = {
	className: undefined,
};

Advert.propTypes = {
	className: propTypes.string,
	type: propTypes.string.isRequired,
};
